module.exports = __webpack_public_path__ + "img/processing.a35f6046.svg";